import { Action } from 'redux';
import { isType } from 'typescript-fsa';
import { upsertArrayOfDataMappedToIdString } from 'utilities/reducer-helpers';
import * as actions from './actions';
import { BleConnectionHistoryState } from './types';

export const initialState: BleConnectionHistoryState = {
	connectionHistories: [],
};

export function bleConnectionHistoryReducer(
	state: typeof initialState = initialState,
	action: Action
): typeof initialState {
	if (isType(action, actions.GetBleConnectionHistoryAction.done)) {
		const idDataTupleArray = upsertArrayOfDataMappedToIdString(
			action.payload.params.serialNumber,
			action.payload.result,
			state.connectionHistories
		);

		return {
			...state,
			connectionHistories: idDataTupleArray,
		};
	}

	return state;
}
